import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import NavBar from './components/NavBar';
import Posts from './components/Posts';
import Post from './components/Post';
import About from './components/About';
import Footer from './components/Footer';

export default function App() {
  return (
    <Router>
      <NavBar />
      <Container className="full-vh">
        <br />
        <Row>
          <Col xs="12">
            <Routes>
              <Route path="/" exact element={<Posts />} />
              <Route path="/posts/:id" element={<Post />} />
              <Route path="/sobre-mi" element={<About />} />
            </Routes>
          </Col>
        </Row>
        <br />
      </Container>
      <Footer />
    </Router>
  );
}
